import React from "react";
import { styled } from '@mui/material/styles';
import Modal from "@mui/material/Modal";

const PREFIX = 'Modal';

const classes = {
  paper: `${PREFIX}-paper`,
  header: `${PREFIX}-header`,
  hi: `${PREFIX}-hi`,
  email: `${PREFIX}-email`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.paper}`]: {
    position: "absolute",
    width: "600px",
    height: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "5px",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
  },

  [`& .${classes.header}`]: {
    color: "#0078a9",
    display: "flex",
    justifyContent: "center",
  },

  [`& .${classes.hi}`]: {
    marginBottom: "3em",
    display: "flex",
    justifyContent: "center",
  },

  [`& .${classes.email}`]: {
    color: "#005287",
    fontWeight: 600,
  }
}));

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

export default function SimpleModal({ open }) {


  const [modalStyle] = React.useState(getModalStyle);

  return (
    <Root>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
      >
        <div style={modalStyle} className={classes.paper}>
          <h2 className={classes.header}>Hazus Loss Library</h2>
          <p className={classes.hi}>
            Hi, thanks for visiting the Hazus Loss Library!
          </p>
          <h3>Need Help?</h3>
          <p>
            You can search for a natural diaster event or location in the US and
            click on it to view our collection of analyses. Each analysis will
            expand and show a list of downloadable products or links. If you
            need further assistance, our support team would be happy to assist
            you. Please email
            <span className={classes.email}> 
              <a href="mailto:fema-hazus-support@fema.dhs.gov?subject='HLL Help'">
                fema-hazus-support@fema.dhs.gov</a>
            </span>
            with the subject line
            <span className={classes.email}> HLL Help </span>
            to get help.
          </p>
          <h3>Report an Issue</h3>
          <p>
            Did you find an issue? We would love to get it resolved as soon as
            we can. Please email
            <span className={classes.email}> 
              <a href="mailto:fema-hazus-support@fema.dhs.gov?subject='HLL Issue'">
                fema-hazus-support@fema.dhs.gov</a>
            </span>
            with the subject line
            <span className={classes.email}> HLL Issue </span>
            to report an issue.
          </p>
          <h3>Contribute Data</h3>
          <p>
            We have dreams of soliciting data from experts around the country
            and sharing it with the world, but at this time we are only able to
            host our internal analyses. While we figure out things on our end,
            reach out to our application support team and add your name to our
            list of future contributors. Please email
            <span className={classes.email}> 
              <a href="mailto:fema-hazus-support@fema.dhs.gov?subject='HLL Contribution'">
                fema-hazus-support@fema.dhs.gov</a>
            </span>
            with the subject line
            <span className={classes.email}> HLL Contribution </span>
            to get added.
          </p>
        </div>
      </Modal>
    </Root>
  );
}
